import './assets/main.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { setupConsent } from './consent';

const app = createApp(App);

app.use(router);

const isEmbedded = new URLSearchParams(window.location.search).get('embedded') === 'true';
if (!isEmbedded) {
  setupConsent(app);
}

app.mount('#app');
